export default __webpack_public_path__ + "static/media/ico-mysql-score-elevated.728422f3.svg";